import React from 'react';

const Ellipsis = () => {
  return <i className="material-icons text-link-text w-8">more_vertic</i>;
};

export default Ellipsis;
